import { Pipe, PipeTransform } from "@angular/core";

import { ORGANIZATION_ADMIN, PROJECT_ADMIN, PROJECT_MONITOR, SYSTEM_ADMIN } from 'app/types/authority';



@Pipe({
  name: 'role'
})
export class RolePipe implements PipeTransform {
  transform(value: string): string {
    switch (value) {
      case SYSTEM_ADMIN:
        return $localize`:@@global.label.systemAdmin:System Manager`;
      case ORGANIZATION_ADMIN:
        return $localize`:@@global.label.organizationAdmin:Organization Manager`;
      case PROJECT_ADMIN:
        return $localize`:@@global.label.studyAdmin:Study Manager`;
      case PROJECT_MONITOR:
        return $localize`:@@global.label.studyMonitor:Study Monitor`;
    }

    return value;
  }
}
